import gql from "graphql-tag";

const RemoveUser = gql`
  mutation RemoveUser($id: ID!) {
    removeUser(id: $id)
  }
`;

export default RemoveUser;
